import { LabelTextGroupCombinedProps } from './types';

const usePresenter = (props: LabelTextGroupCombinedProps): LabelTextGroupCombinedProps => {
  return props;
};

export default usePresenter;
